/**
 * @file 号码卡片
 * @author (zhaomiaoyuan@baidu.com)
 */

import React, {useState, useEffect} from 'react';
import {withRouter} from 'react-router';
import PropTypes from 'prop-types';
import {Swiper, SwiperSlide} from 'swiper/react';
import SwiperCore, {Pagination, Navigation, Autoplay} from 'swiper';
import 'swiper/swiper.less';
import 'swiper/components/navigation/navigation.less';

import MultiPhonePreview from './multiPhonePreview';
import SinglePhonePreview from './singlePhonePreview';
import {getPhones} from './conf';

import './phoneCard.less';

SwiperCore.use([Pagination, Navigation, Autoplay]);

const PhoneCard = props => {
    const {detail} = props;

    const [displayCard, setDisplayCard] = useState(getPhones(detail.phones || []));

    useEffect(() => {
        setDisplayCard(getPhones(detail.phones || []));
    }, [detail]);

    function card(data) {
        const phones = data.card;
        const displayName = phones[0].display;
        const trademarkDisplayName = phones[0].trademarkDisplay;
        const name = displayName ? displayName + '客服' : trademarkDisplayName ? trademarkDisplayName + '客服' : '';
        return (
            <div style={{position: 'relative'}}>
                <div className="phone-card-item-shadow"></div>
                <div className="phone-card-item">
                    <span className={'selphone1'}>{name}</span>
                    {phones.length > 1 ? (
                        <MultiPhonePreview phones={phones} name={name} iconSrc={''}></MultiPhonePreview>
                    ) : (
                        <SinglePhonePreview phones={phones} name={name} iconSrc={''}></SinglePhonePreview>
                    )}
                </div>
            </div>
        );
    }

    return (
        <div className="phone-card">
            <Swiper
                slidesPerView={1}
                // autoplay={{
                //     delay: 3000,
                //     stopOnLastSlide: false,
                //     disableOnInteraction: false
                // }}
                className={'phone-card-swiper-box'}
                pagination={{
                    type: 'fraction',
                    el: '.swiper-pagination'
                }}
                navigation={{
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                }}
            >
                {displayCard.map((item, i) => {
                    return <SwiperSlide key={i}>{card(item)}</SwiperSlide>;
                })}

                <div className="swiper-button-next"></div>
                <div className="swiper-button-prev"></div>
                <div className="swiper-pagination"></div>
            </Swiper>
        </div>
    );
};
PhoneCard.propTypes = {
    detail: PropTypes.object
};
export default withRouter(PhoneCard);
